import React from 'react'
import {Form, Input, Select} from "antd";
import config from "../../config";

const { Option } = Select

const WarehouseReportsFilter = () => {

    return(
        <React.Fragment>
            <Form.Item
                name={'name'}
                label={'Depo Adı'}
                initialValue={''}
            >
                <Input />
            </Form.Item>
            <Form.Item
                name={'currency'}
                label={'Para Birimi'}
                initialValue={''}
            >
                <Select>
                    {
                        config.currencyOptions.map(item => <Option key={item} value={item}>{item}</Option>)
                    }
                </Select>
            </Form.Item>
        </React.Fragment>
    )
}

export default WarehouseReportsFilter